const isDevelopment = process.env.NODE_ENV === "development";
export const url: string = isDevelopment
? "https://api.reviro.tech.anroit.com"
: `https://api.${window.location.hostname}`;